import { render, staticRenderFns } from "./childOrderInvoiceInfo.vue?vue&type=template&id=4bb9e69e&scoped=true"
import script from "./childOrderInvoiceInfo.vue?vue&type=script&lang=js"
export * from "./childOrderInvoiceInfo.vue?vue&type=script&lang=js"
import style0 from "./childOrderInvoiceInfo.vue?vue&type=style&index=0&id=4bb9e69e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9e69e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb9e69e')) {
      api.createRecord('4bb9e69e', component.options)
    } else {
      api.reload('4bb9e69e', component.options)
    }
    module.hot.accept("./childOrderInvoiceInfo.vue?vue&type=template&id=4bb9e69e&scoped=true", function () {
      api.rerender('4bb9e69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/detailBox/components/childOrderInvoiceInfo.vue"
export default component.exports